import { Route, UrlMatchResult, UrlSegment } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect raíz
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Aliases
    { matcher: tripRequestAliasMatcher, redirectTo: 'trip-request' },
    { matcher: calendarRequestAliasMatcher, redirectTo: 'calendar-requests' },

    // ===== Flujos "externos" sin menú (layout vacío) PARA INVITADOS =====
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            // Auth públicas
            {
                path: 'confirmation-required',
                loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes'),
            },
            {
                path: 'forgot-password',
                loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes'),
            },
            {
                path: 'reset-password',
                loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes'),
            },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
            {
                path: 'invite',
                loadComponent: () =>
                    import('app/modules/auth/invitation/invitation.component').then((c) => c.InvitationComponent),
            },

            // Tus dos “micro-apps” sin menú
            {
                path: 'trip-request',
                loadChildren: () => import('app/modules/auth/one-time-login/one-time-login.routes'),
            },
        ],
    },

    // ===== Rutas auxiliares autenticadas (layout vacío) =====
    {
        path: '',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            {
                path: 'mcp',
                loadComponent: () => import('app/modules/mcp/mcp.component').then((c) => c.McpComponent),
            },
            {
                path: 'calendar-requests',
                loadChildren: () => import('app/modules/landing/calendar/calendar-request/calendar-request.routes'),
            },
            {
                path: 'auth/finalize',
                loadChildren: () =>
                    import('app/modules/auth/finalize/auth-finalize.routes'),
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            {
                path: 'unlock-session',
                loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes'),
            },
        ],
    },

    // ===== APP principal con menú (protegida) =====
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: { initialData: initialDataResolver },
        children: [
            { path: 'dashboard', loadChildren: () => import('app/modules/landing/dashboard/dashboard.routes') },
            { path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes') },
            { path: 'calendar', loadChildren: () => import('app/modules/landing/calendar/calendar.routes') },
            { path: 'aircraft', loadChildren: () => import('app/modules/landing/aircrafts/aircrafts.routes') },
            { path: 'people', loadChildren: () => import('app/modules/landing/people/people.routes') },
            {
                path: 'duties',
                data: { requiresFeature: 'flightHours' },
                loadChildren: () => import('app/modules/landing/duties/duties.routes'),
            },
            { path: 'settings', loadChildren: () => import('app/modules/admin/settings/settings.routes') },
            { path: 'help', loadChildren: () => import('app/modules/landing/help/help.routes') },
            { path: 'trips', loadChildren: () => import('app/modules/landing/trips/trips.routes') },
            {
                path: 'quotes',
                data: { requiresFeature: 'quotes' },
                loadChildren: () => import('app/modules/landing/quotes/quotes.routes'),
            },
            {
                path: 'reports',
                data: { requiresFeature: 'csvExport' },
                loadChildren: () => import('app/modules/landing/reports/reports.routes'),
            },
            // Catch-all dentro del área autenticada
            { path: '**', redirectTo: 'dashboard' },
        ],
    },
];

// --- Matchers ---
export function tripRequestAliasMatcher(segments: UrlSegment[]): UrlMatchResult | null {
    if (segments.length !== 1) return null;
    const norm = segments[0].path.toLowerCase().replace(/[^a-z0-9]/g, '');
    const singular = norm.endsWith('s') ? norm.slice(0, -1) : norm;
    return singular === 'triprequest' ? { consumed: segments } : null;
}

export function calendarRequestAliasMatcher(segments: UrlSegment[]): UrlMatchResult | null {
    if (segments.length !== 1) return null;
    const norm = segments[0].path.toLowerCase().replace(/[^a-z0-9]/g, '');
    const singular = norm.endsWith('s') ? norm.slice(0, -1) : norm; // acepta /calendar-request y /calendar-requests
    return singular === 'calendarrequest' ? { consumed: segments } : null;
}
